module.exports = __webpack_public_path__ + "static/crush-the-curve-dark-mode-bbe7af51745c92b913acd3d180ffa5ce.svg";